import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/*
 * context
 */

export var SELECT_OUTCOME_IDS = 'SELECT_OUTCOME_IDS';
export var SET_ERROR = 'SET_ERROR';
export var SET_OUTCOMES = 'SET_OUTCOMES';
export var SET_OUTCOME_PICKER_STATE = 'SET_OUTCOME_PICKER_STATE';
export var SET_ROOT_OUTCOME_IDS = 'SET_ROOT_OUTCOME_IDS';
export var SET_SELECTED_OUTCOME_IDS = 'SET_SELECTED_OUTCOME_IDS';
export var UNSELECT_OUTCOME_IDS = 'UNSELECT_OUTCOME_IDS';
export var SET_SCORING_METHOD = 'SET_SCORING_METHOD';
export var SET_FEATURES = 'SET_FEATURES';
export var SET_CONTEXT = 'SET_CONTEXT';

/*
 * alignments
 */

export var SET_ALIGNMENTS = 'SET_ALIGNMENTS';
export var VIEW_ALIGNMENT = 'VIEW_ALIGNMENT';
export var CLOSE_ALIGNMENT = 'CLOSE_ALIGNMENT';
export var UPDATE_ALIGNMENT = 'UPDATE_ALIGNMENT';
export var SET_LAUNCH_CONTEXTS = 'SET_LAUNCH_CONTEXTS';

/*
 * picker
 */

export var SET_FOCUSED_OUTCOME = 'SET_FOCUSED_OUTCOME';
export var SET_ACTIVE_COLLECTION_ID = 'SET_ACTIVE_COLLECTION_ID';
export var TOGGLE_EXPANDED_IDS = 'TOGGLE_EXPANDED_IDS';
export var RESET_EXPANDED_IDS = 'RESET_EXPANDED_IDS';
export var SET_SCOPE = 'SET_SCOPE';
export var RESET_OUTCOME_PICKER = 'RESET_OUTCOME_PICKER';
export var SET_SELECTED_LAUNCH_CONTEXT = 'SET_SELECTED_LAUNCH_CONTEXT';

/*
 * reporting
 */

export var SET_REPORT_PAGE = 'SET_REPORT_PAGE';
export var SET_REPORT_PAGE_DATA = 'SET_PAGE_DATA';
export var SET_REPORT_OUTCOMES = 'SET_REPORT_OUTCOMES';
export var SET_REPORT_ROLLUPS = 'SET_REPORT_ROLLUPS';
export var SET_REPORT_RESULTS = 'SET_REPORT_RESULTS';
export var SET_REPORT_USERS = 'SET_REPORT_USERS';
export var SET_REPORT_LOADING = 'SET_REPORT_LOADING';
export var SET_REMAINING_PAGES_LOADING = 'SET_REMAINING_PAGES_LOADING';
export var CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';
export var VIEW_REPORT_ALIGNMENT = 'VIEW_REPORT_ALIGNMENT';
export var CLOSE_REPORT_ALIGNMENT = 'CLOSE_REPORT_ALIGNMENT';
export var ALL_USERS = 'ALL_USERS';
export var NOT_FETCHING = 'NOT_FETCHING';
export var IN_PROGRESS = 'FETCHING_IN_PROGRESS';
export var ERROR = 'FETCHING_ERROR';
export var COMPLETED = 'FETCHING_COMPLETED';

// CSV Report Headers
export var STUDENT_NAME = 'student_name';
export var STUDENT_UUID = 'student_uuid';
export var ATTEMPT_COUNT = 'attempt_count';
export var ALIGNED_QUESTIONS_COUNT = 'aligned_questions_count';
export var LOR_POINTS = 'lor_points';
export var LOR_POINTS_POSSIBLE = 'lor_points_possible';
export var LO_NAME = 'lo_name';
export var LO_ID = 'lo_id';
export var LO_MASTERY_PERCENT = 'lo_mastery_percent';
export var LO_MASTERED = 'lo_mastered';

/*
 * search
 */
export var SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export var SET_SEARCH_PAGE = 'SET_SEARCH_PAGE';
export var SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';
export var SET_SEARCH_ENTRIES = 'SET_SEARCH_ENTRIES';
export var SET_SEARCH_TOTAL = 'SET_SEARCH_TOTAL';

/*
* tray
*/
export var SET_OUTCOME_LIST = 'SET_OUTCOME_LIST';
export var SET_LIST_PAGE = 'SET_LIST_PAGE';
export var SET_LIST_TOTAL = 'SET_LIST_TOTAL';

/*
 * student mastery
 */
export var SET_INDIVIDUAL_RESULTS = 'SET_INDIVIDUAL_RESULTS';
export var SET_INDIVIDUAL_RESULTS_STATE = 'SET_INDIVIDUAL_RESULTS_STATE';

/*
 * add feature flags here as strings
 * this being a function allows it to be stubbed in tests
*/

export var REPORT_DOWNLOAD_FF = 'report_download';
export var NEW_DECAYING_AVERAGE_FF = 'outcomes_new_decaying_average_calculation';
export var getFeatureFlags = function getFeatureFlags() {
  return [REPORT_DOWNLOAD_FF, NEW_DECAYING_AVERAGE_FF];
};

/*
 * calculation method
 */

export var HIGHEST = 'highest';
export var LATEST = 'latest';
export var N_MASTERY = 'n_mastery';
export var DECAYING_AVERAGE = 'decaying_average';
export var STANDARD_DECAYING_AVERAGE = 'standard_decaying_average';
export var WEIGHTED_AVERAGE = 'weighted_average';
export var AVERAGE = 'average';
export var CALCULATION_METHODS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, HIGHEST, 'Highest Score'), LATEST, 'Most Recent Score'), N_MASTERY, 'Achieve Mastery {n} times'), DECAYING_AVERAGE, 'Decaying Average - {percent}%/{complement}%'), WEIGHTED_AVERAGE, 'Weighted Average - {percent}%/{complement}%'), STANDARD_DECAYING_AVERAGE, 'Decaying Average - {percent}%/{complement}%'), AVERAGE, 'Average');